import { AsyncStateAlert } from '@ui/general';
import { createAsyncSelectors } from '@lib/selectors';
import { GatewayCard } from '../general';
import { NewPassword } from '@ui/form-items';
import { securityActions } from '@sonar-software/sonar-security';
import { SonarText } from '@ui/text';
import { Button, Form, Row } from 'antd';
import { COPY_SPECIFIC, FULL_ROUTES, MESSAGES_COPY, NOTIFICATIONS_COPY, PASSWORD, RESET_PASSWORD_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect } from 'react';
import { useAction, useSonarSelector } from '@hooks';
import { useNavigate, useParams } from 'react-router-dom';
const rules = [
    {
        max: PASSWORD.MAX_LENGTH,
        message: MESSAGES_COPY.PLEASE_ENTER_NEW_PASSWORD,
        min: PASSWORD.MIN_LENGTH,
        pattern: PASSWORD.PATTERN,
        required: true,
        type: 'string'
    }
];
const resetPasswordSelectors = createAsyncSelectors((state) => state.security.authentication.resetPassword.post);
export const ResetPasswordView = () => {
    const navigate = useNavigate();
    const { token } = useParams();
    const isErrored = useSonarSelector(resetPasswordSelectors.isErrored);
    const isFailed = useSonarSelector(resetPasswordSelectors.isFailed);
    const isRequested = useSonarSelector(resetPasswordSelectors.isRequested);
    const isSuccessful = useSonarSelector(resetPasswordSelectors.isReceived);
    const requestPasswordReset = useAction(securityActions.requestPostSecurityAuthenticationResetPassword);
    const resetPasswordReset = useAction(securityActions.resetPostSecurityAuthenticationResetPassword);
    const disabled = isRequested || isSuccessful;
    const goToLogin = useCallback(() => {
        navigate(FULL_ROUTES.LOGIN);
    }, [navigate]);
    const handleOnFinish = useCallback((values) => {
        requestPasswordReset({
            newPassword: values.password,
            token: token !== null && token !== void 0 ? token : ''
        });
    }, [requestPasswordReset, token]);
    const handleOnValuesChange = useCallback(() => {
        if (isErrored || isFailed) {
            resetPasswordReset();
        }
    }, [isErrored, isFailed, resetPasswordReset]);
    useEffect(() => {
        if (isSuccessful) {
            setTimeout(() => {
                goToLogin();
            }, 3500);
        }
    }, [goToLogin, isSuccessful]);
    return (React.createElement(GatewayCard, { id: 'reset-password', title: RESET_PASSWORD_COPY.RESET_PASSWORD_HEADER },
        React.createElement(Form, { onFinish: handleOnFinish, onValuesChange: handleOnValuesChange },
            React.createElement(SonarText, { className: 'sub-text' }, RESET_PASSWORD_COPY.RESET_PASSWORD_SUBTEXT),
            React.createElement(AsyncStateAlert, { errored: NOTIFICATIONS_COPY.ERROR_RESET_PASSWORD, failed: NOTIFICATIONS_COPY.FAILED_RESET_PASSWORD, received: NOTIFICATIONS_COPY.SUCCESS_RESET_PASSWORD, stateSelector: resetPasswordSelectors.state }),
            React.createElement(Form.Item, { id: 'reset-password-new', name: 'password', rules: rules },
                React.createElement(NewPassword, { disabled: disabled, size: 'large' })),
            React.createElement(Row, { justify: 'space-between' },
                React.createElement(Button, { disabled: disabled, id: 'reset-password-return-button', onClick: goToLogin }, COPY_SPECIFIC.BACK_TO_LOGIN),
                React.createElement(Button, { htmlType: 'submit', id: 'reset-password-submit-button', loading: disabled, type: 'primary' }, COPY_SPECIFIC.RESET_PASSWORD)))));
};
